export default {
  'Watermark': 'Filigrana',
  'Add Watermark Selection': 'Aggiunge Filigrana Selezionata',
}